module.exports = __webpack_public_path__ + "img/ic_wx_qr_code.e576ee6d.png";